import { ReactNode, useRef } from 'react';
import { styled } from '@mui/material';
import { kebabCase } from 'lodash/fp';

export function TabPanel({ children, value, label, ...other }: TabPanelProps) {
  const root = useRef(null);

  return (
    <Wrapper
      ref={root}
      role="tabpanel"
      id={`tabpanel-${value}`}
      aria-labelledby={kebabCase(label)}
      tabIndex={-1}
      {...other}>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled('div')(({ theme }) => ({
  '& > *+*': {
    marginTop: '1rem',
  },
  '&:focus': {
    outline: 'none',
  },
}));

interface TabPanelProps {
  children?: ReactNode;
  value: number;
  label: string;
}
